import { Text } from "@fluentui/react-components";
import { formatNumber } from "library/utils";
import styled from "styled-components";

export const CustomTooltip = (props) => {
  const { active, payload } = props;

  if (active && payload && payload.length) {
    return (
      <Container
        style={{
          borderRadius: "4px",
          padding: "10px",
        }}
      >
        <Text
          weight="bold"
          size={300}
        >{`${payload[0].payload.name} : ${formatNumber(payload[0].value)} ${payload[0].payload.currency}`}</Text>
      </Container>
    );
  }

  return null;
};

const Container = styled.div`
  background: rgba(255, 255, 255, 0.7);

  color: ${(props) => props.theme.palette.purpleDark};
`;
